/**
 * 应用基础配置
 * 职责：应用名称、版本等基础信息
 */

export const APP_CONFIG = {
  // 应用信息
  NAME: '食品数字标签生成系统',
  VERSION: '1.0.0',
  DESCRIPTION: '智能化食品标签生成与管理平台',
  
  // 语言配置
  DEFAULT_LANG: 'zh-CN',
  SUPPORTED_LANGS: ['zh-CN', 'en-US'],
  
  // 默认页面标题
  PAGE_TITLE: '食品数字标签生成系统',
};

export default APP_CONFIG;

